// extracted by mini-css-extract-plugin
module.exports = {"root":"_576eb8","backgroundImageContainer":"_4156e1","backgroundSvg":"_1968f5","content":"_bae0ec"};